<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    class="verify-box"
    style="width:500px;"
  >
    <el-dialog
      title="补发寄出"
      :visible="true"
      :before-close="onCloseDialog"
      width="400px"
    >
      <el-form>
        <el-select v-model="shipping_name" size="mini" placeholder="快递公司">
          <el-option
            v-for="item in shipping_company"
            :key="item.shipping_name"
            :label="item.shipping_company"
            :value="item.shipping_name"
          >
          </el-option>
        </el-select>

        <el-form-item label="快递单号：">
          <el-input
            v-model="shipping_num"
            style="width:300px;"
            size="small"
            placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitData"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    work_id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      shipping_num: "",
      shipping_name: "",
      shipping_company: [],
      url: "/erp/Work/sendBf",
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    submitData() {
      this.$http
        .post(this.url, {
          work_id: this.work_id,
          shipping_num: this.shipping_num,
          shipping_name: this.shipping_name,
        })
        .then(res => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            this.onCloseDialog();
          }
        });
    },
    fetchData() {
      this.$http.get(this.url).then(res => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.shipping_company = res.data.data.shipping_company;
        }
      });
    },
    onCloseDialog() {
      this.$emit("onCloseDialog", false);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/work/components/SendBf.vue